import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftItemInfo,
  GiftItemInfoCreate,
  GiftItemInfoUpdate,
} from './giftItemInfo.interface';

export const getGiftItemInfoList = async (role: LowerRole) => {
  const { data } = await api_.get<GiftItemInfo[]>(
    `${role}/gift-item-info?populate=["image","detailImages","deliveredImageList"]`,
  );
  return data;
};

export const getGiftItemInfo = async (id: string, role: LowerRole) => {
  const { data } = await api_.get<GiftItemInfo>(
    `${role}/gift-item-info/${id}?populate=["image","detailImages","deliveredImageList"]`,
  );
  return data;
};

export const createGiftItemInfo = async (
  giftItemInfo: GiftItemInfoCreate,
  role: LowerRole,
) => {
  const { data } = await api_.post<GiftItemInfo>(`${role}/gift-item-info`, giftItemInfo);
  return data;
};

export const updateGiftItemInfo = async (
  giftItemInfo: GiftItemInfoUpdate,
  role: LowerRole,
) => {
  const { data } = await api_.patch<GiftItemInfo>(
    `${role}/gift-item-info/${giftItemInfo._id}`,
    giftItemInfo,
  );
  return data;
};

export const deleteGiftItemInfo = async (id: string, role: LowerRole) => {
  const { data } = await api_.delete(`${role}/gift-item-info/${id}`);
  return data;
};
